import React, { useEffect, useState } from "react";
import Loader from "./Loader";

const ConfirmationPopup = ({
    isOpen,
    title,
    message,
    onClose,
    onConfirm = false,
    onDiscard = false,
    
    loading,
    showCancelButton = true,
    actionType = "confirm",
    isSuccess = false, // New prop to indicate success state
}) => {
    const [showLoader, setShowLoader] = useState(true);

    useEffect(() => {
        if (isOpen) {
            document.documentElement.style.overflow = "hidden";
            document.body.style.overflow = "hidden";

            setShowLoader(true);
            const timer = setTimeout(() => {
                setShowLoader(false);
            }, 1000);

            return () => {
                clearTimeout(timer);
                document.documentElement.style.overflow = "auto";
                document.body.style.overflow = "auto";
            };
        }
    }, [isOpen]);

    if (!isOpen) return null;
    

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-d">
            {showLoader ? (
                <Loader />
            ) : (
                <div className="bg-white p-[15px] pt-[25px] rounded-[27px] shadow-xl w-[22%] md:w-[50%] sm:w-[91%] relative flex flex-col items-center">
                    {/* Close Button */}
                    <p className="text-gray-600 text-center flex items-center justify-center  p-[1px]">
                    {actionType === "success" && (
                        <img
                            src="https://jobcritics.com/assets/img/biar/success.webp"
                            alt="Success"
                            className="w-[150px]  mr-2"
                        />
                    )}
                    {actionType === "delete" && (
                        <img
                            src="https://jobcritics.com/assets/img/biar/delete_logo.webp"
                            alt="Delete"
                            className="w-[150px] mr-2"
                        />
                    )}
                    {actionType === "onDiscard" && (
                        <img
                            src="https://jobcritics.com/assets/img/biar/discard.webp"
                            alt="Delete"
                            className="w-[150px] mr-2"
                        />
                    )}
                    {actionType === "report" && (
                        <img
                            src="https://jobcritics.com/assets/img/biar/report.webp"
                            alt="Delete"
                            className="w-[150px] mr-2"
                        />
                    )}
                    </p>
                    {/* 
                    Title & Message */}
                    <h6 className="font-semibold text-black text-center w-full mb-0 mt-[14px] pb-[5px]">{title}</h6>

                    <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[15px]">{message}</p>

                    {/* Success Message with Icon */}


                    {/* Buttons */}
                    {!isSuccess && (
                        <div className="grid mt-[11px] w-full gap-3 w-full justify-center">
                            {showCancelButton ? (
                                <>

{actionType === "onDiscard" && (
                                        <button
                                            className="btn-explore-yellow text-c pd3 !w-[294px]"
                                            onClick={onDiscard}
                                            disabled={loading}
                                        >
                                            Discard
                                        </button>
                                    )}
                                   
                                    
                                    {onConfirm && (
                                        <button
                                            className=" btn-explore-yellow  text-c pd3 !w-[294px]"
                                            onClick={onConfirm}
                                            disabled={loading}
                                        >

                                            {actionType === "delete"
                                                ? "Delete"
                                                : (actionType === "report"
                                                    ? "Report"
                                                    : (actionType === "remindmelater"?"Complete Now": "Confirm"))}
                                        </button>
                                    )}
                                   {
                                    actionType === "remindmelater"?(<p
                                        className="text-gray-700  hover:text-base hover:bg-gray-200 hover:rounded-[24px] cursor-pointer text-center text-c !p-[8px] !w-[300px] "
                                        onClick={onClose}
                                    >
                                        Remind Me Later
                                    </p>):(<p
                                        className="text-gray-700  hover:text-base hover:bg-gray-200 hover:rounded-[24px] cursor-pointer text-center text-c !p-[8px] !w-[300px] "
                                        onClick={onClose}
                                    >
                                        CLOSE
                                    </p>)
                                   }
                                    
                                </>
                            ) : (
                                <button
                                    className="btn-explore-yellow text-c pd3 dsfa"
                                    onClick={onConfirm}
                                    disabled={loading}
                                >
                                    OK
                                </button>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ConfirmationPopup;